module.exports = __webpack_public_path__ + "static/img/1901_3.efc9280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_3.jpg
// module id = N00z
// module chunks = 1